import { compose, withProps, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import {
  actions as orderActions,
  selectors as orderSelector,
  selectorsByType,
} from 'state/order';

import { formatters as dateFormatters } from 'utils/dateAndTimes';
import { joinElementsWithSeparatorAndEndingSeparator } from 'utils/array';

import { isEmpty } from 'utils/types';

import Holidays from 'components/Recurring/Holidays/component';

const enhance = compose(
  withTranslation('Recurring'),
  connect(
    (state) => {
      const typeOfOrder = orderSelector.getTypeOfOrder(state);
      return {
        holidays: selectorsByType.holidays[typeOfOrder].getHolidays(state),
      };
    },
    {
      fetchHolidays: orderActions.fetchHolidays,
    }
  ),
  lifecycle({
    componentDidMount() {
      const { fetchHolidays, holidays } = this.props;

      if (isEmpty(holidays)) fetchHolidays();
    },
  }),
  withProps(({ t, holidays }) => {
    const holidaysJoined = joinElementsWithSeparatorAndEndingSeparator(
      holidays.sort().map((date) =>
        dateFormatters.getHumanReadableFormattedDate({
          value: date,
          t,
        })
      ),
      ', ',
      t('Recurring:and')
    );

    return {
      nextHolidays: t('summary.next_holidays'),
      holidays: holidaysJoined,
      hasHolidays: holidays.length > 0,
    };
  })
);

export default enhance(Holidays);
// Próximos festivos coincidentes con este envío:
